<template>
    <div class="card card-with-table">
        <div class="card-body">
            <table class="table table-striped table-hover">
                <thead>
                    <tr>
                        <th>Дата</th>
                        <th style="max-width: 150px">ТА</th>
                        <th>Продажи</th>
                    </tr>
                </thead>

                <tbody v-for="(vms, date) in sales" :key="date">
                    <tr v-for="(vm, index) in vms" :key="index + '_' + date">
                        <td style="position: sticky; top:45px;">
                            <div v-if="index == 0" class="btn btn-outline-primary active">{{ date }}</div>
                        </td>
                        <td>
                            <div style="position: sticky; top:68px">
                                <router-link :to="{ name: 'vm', params: { id: vm.id }}">{{ vm.name }}</router-link>
                            </div>
                        </td>
                        <td>
                            <report-sales-details :value="vm.products" :currency="currency" />
                        </td>
                    </tr>
                </tbody>

                <tfoot v-if="sales.length === 0 && !needUpdate" class="text-center text-muted">
                    <tr>
                        <td colspan="42">
                            Нет продаж за выбранный период.
                        </td>
                    </tr>
                </tfoot>

                <tfoot v-if="sales.length === 0 && needUpdate" class="text-center text-muted">
                    <tr>
                        <td colspan="42">
                            Выберите необходимые параметры, а затем постройте новый отчет
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>

<script>
import ReportSalesDetails from '@/components/ReportSalesDetails'

export default {
    components: {
        ReportSalesDetails
    },

    props: {
        sales: {
            type: Array | Object,
            default: _ => []
        },

        currency: {
            type: Number,
            default: null
        },

        needUpdate: {
            type: Boolean,
            default: true
        }
    }
}
</script>

<style lang="scss" scoped>
.table-vend-list {
    thead {
        th {
            line-height: 1rem;
            vertical-align: middle;

            &:nth-child(2) {
                width: 100%;
            }

            &:nth-child(5) {
                width: 150px;
            }
        }
    }

    tbody {
        tr {
            td {
                vertical-align: middle;
            }
        }
    }
}
</style>
